import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
    AuthenticationRequestOtpMessage,
    DeviceRegistration,
    DeviceRegistrationPatch,
    FidoAuthenticationRequest,
    FidoAuthenticationResponse,
    FidoUafRegistrationRequest,
    FidoUafRegistrationResponse,
    SessionBindingInfo,
    SessionBindingPatch
} from './authenticatie-fido.model';

@Injectable({ providedIn: 'root' })
export class ApAuthenticatieFidoResource {
    private readonly httpClient = inject(HttpClient);

    private readonly baseUrl: string = '/services/apic-authenticatie-fido/api';

    public getOneRegistrationRequest(registrationId: string): Observable<FidoUafRegistrationRequest> {
        return this.httpClient.get<FidoUafRegistrationRequest>(`${this.baseUrl}/fido-uaf-registration-requests/${registrationId}`);
    }

    public putOneRegistrationResponse(registrationId: string, registrationResponse: FidoUafRegistrationResponse): Observable<void> {
        return this.httpClient.put<void>(`${this.baseUrl}/fido-uaf-registration-responses/${registrationId}`, registrationResponse);
    }

    public postOneDeviceRegistration(deviceRegistration: DeviceRegistration): Observable<string> {
        return this.httpClient
            .post<void>(`${this.baseUrl}/device-registrations`, deviceRegistration, {
                observe: 'response'
            })
            .pipe(map((response) => response.headers.get('X-Resource-Id')));
    }

    public patchOneDeviceRegistration(registrationId: string, deviceRegistration: DeviceRegistrationPatch): Observable<void> {
        const options = {
            headers: {
                'Content-Type': 'application/merge-patch+json' // eslint-disable-line
            }
        };
        return this.httpClient.patch<void>(`${this.baseUrl}/device-registrations/${registrationId}`, deviceRegistration, options);
    }

    public getOneAuthenticationRequest(authenticationId: string): Observable<FidoAuthenticationRequest> {
        return this.httpClient.get<FidoAuthenticationRequest>(`${this.baseUrl}/fido-uaf-authentication-requests/${authenticationId}`);
    }

    public putOneAuthenticationResponse(authenticationId: string, authenticationResponse: FidoAuthenticationResponse): Observable<void> {
        return this.httpClient.put<void>(`${this.baseUrl}/fido-uaf-authentication-responses/${authenticationId}`, authenticationResponse);
    }

    public postOneAuthenticationRequestOtpMessage(otpMessage: AuthenticationRequestOtpMessage): Observable<void> {
        return this.httpClient.post<void>(`${this.baseUrl}/authentication-request-otp-messages`, otpMessage);
    }

    public getOneAuthenticationTaskSessionBinding(authenticationId: string): Observable<SessionBindingInfo> {
        return this.httpClient.get<SessionBindingInfo>(`${this.baseUrl}/authentication-task-session-bindings/${authenticationId}`);
    }

    public patchOneAuthenticationTaskSessionBinding(
        authenticationId: string,
        sessionBindingPatch: SessionBindingPatch
    ): Observable<SessionBindingInfo> {
        return this.httpClient.patch<SessionBindingInfo>(
            `${this.baseUrl}/authentication-task-session-bindings/${authenticationId}`,
            sessionBindingPatch,
            {
                headers: {
                    'Content-Type': 'application/merge-patch+json' // eslint-disable-line
                }
            }
        );
    }
}
